const HIGHARC_EMAIL_SUFFIX = "@higharc.com";

/**
 * True for any @higharc.com address. Case-insensitive because email domains are case-insensitive
 * (SES delivers to `Me@Higharc.com`). Single source of truth for the mailer's external-address
 * filter and the share-plan recipient gate so the two cannot disagree.
 */
export function isHigharcEmailAddress(email: string): boolean {
  return email.trim().toLowerCase().endsWith(HIGHARC_EMAIL_SUFFIX);
}

/**
 * Email domains used by Higharc employees. `higharc.ai` is the current corporate
 * domain; `higharc.com` predates it and remains valid. Used server-side to
 * exclude staff from the suspicious-user sweep and to gate staff-only cleanup.
 */
export const HIGHARC_EMPLOYEE_EMAIL_DOMAINS: string[] = ["higharc.com", "higharc.ai"];

/**
 * Returns true if the email's domain is one of the Higharc-employee domains.
 * Case-insensitive. Anything missing an `@` returns false.
 */
export function isHigharcEmployeeEmail(email: string | null | undefined): boolean {
  if (!email) {
    return false;
  }
  const lower = email.toLowerCase();
  const at = lower.lastIndexOf("@");
  if (at === -1) {
    return false;
  }
  return HIGHARC_EMPLOYEE_EMAIL_DOMAINS.includes(lower.slice(at + 1));
}
